/**
 * A player's banner, as a layer behind whatever card it sits in. The card needs
 * `has-banner` on it so the layer stays inside its corners and under its text.
 */
export function BannerLayer({
  banner,
  colour,
  strip = false,
}: {
  banner: string | undefined | null;
  colour: string;
  /** Fainter, for a row in a list rather than a card of its own. */
  strip?: boolean;
}) {
  if (!banner || banner === 'none') return null;
  return (
    <span
      aria-hidden
      className={`banner-bg banner-${banner}${strip ? ' strip' : ''}`}
      style={{ ['--banner-c' as string]: colour }}
    />
  );
}

/** The class a card needs to carry a banner. */
export function bannerClass(banner: string | undefined | null): string {
  return banner && banner !== 'none' ? ' has-banner' : '';
}
